export default __webpack_public_path__ + "static/media/vi_Danza2.5322ffc9.mp4";